import React, { Component } from 'react';
import classNames from 'classnames'
import styles from './index.css';
import PAA from '../../blocks/PhoneAndAddress';
import Title from '../../blocks/Title'
import MyIcons from '../../blocks/MyIcons'
import {LangChangeEventContext} from '../../contexts/LangContext';

export default class MainKitchen extends Component {
  componentWillMount(){
    
  }
  componentDidMount(){
    this.props.getHeightKitchen(this.kitchenBody.offsetHeight);
  }
  render() {
    // console.log(this.props);
    return (
      <LangChangeEventContext.Consumer>
        {({lang}) =>(
          <div className={classNames(styles['kitchenBody'], 
              this.props.steps[1] && styles['is-step1'], 
              this.props.steps[2] && styles['is-step2'], 
              this.props.steps[3] && styles['is-step3'], 
              this.props.steps[4] && styles['is-step4'], 
              this.props.steps[5] && styles['is-step5'], 
              this.props.steps[6] && styles['is-step6'], 
              this.props.steps[7] && styles['is-step7'], 
              this.props.steps[8] && styles['is-step8'],
              this.props.steps[9] && styles['is-step9'])
            } 
            
          > 
            <div className={classNames(styles['backgroundImgWrapper'])} >  
              <img alt="" src={this.props.ADMIN_URL+this.props.bg} className={styles['backgroundImg']} />  
            </div>

            <div className={classNames(styles['contentWrapper'])} style={{transform:'translateY('+this.props.valueScroll+'px)'}}>
              <div className={classNames(styles['header'])}>
                <PAA classStyle={styles['paaStyle']} iconPlace='place' iconPhone='phone' colorStyle="black"/>
                <Title colorStyle="black" classStyle={styles['titleStyle']} title={lang.t('kitchenHeader')} text={lang.t('kitchenSubHeader')} />
              </div>
              <div className={classNames(styles['content'])} ref={item => {this.kitchenBody = item}}>  
                <div className={styles['wrapperText']} >  
                  <h3 className={styles['wrapperTextTitle']}>{lang.t('historyTitle')}</h3>
                  <div className={styles['text']} dangerouslySetInnerHTML={{__html: lang.t('kitchenText1') }} >
                  </div>
                  <div className={styles['textGallery']} >
                    {JSON.parse(this.props.gallery2).map( (img,i) => {
                      return(
                        <div className={styles['imgWr']} key={i}>
                          <img alt="" src={this.props.ADMIN_URL+img.image} className={styles['img']} />
                        </div>
                      )
                    })}
                  </div>
                  <div className={styles['spoon']} >
                    <MyIcons icon="spoon" width="100px" height="100px"/>
                  </div>
                  <h3 className={styles['wrapperTextTitle']}>{lang.t('kitchenTitle2')}</h3>
                  <div className={styles['text2']}>
                    <span dangerouslySetInnerHTML={{__html: lang.t('kitchenText2') }} ></span>
                    <div className={styles['spoon2']} >
                      <MyIcons icon="spoon" width="100px" height="100px"/>
                    </div>
                  </div>
                </div>              
                <div className={styles['gallery']} >
                  <div className={styles['galleryImgWrapper']} >
                    <img alt="" src={this.props.ADMIN_URL+JSON.parse(this.props.gallery1)[0].image} className={styles['galleryImg']} />
                  </div>  
                  <div className={classNames(styles['videoKitchen'],styles['galleryImgWrapper'])} ref={item=>{this.videoKitchen = item}}
                    // dangerouslySetInnerHTML={{__html: this.props.video}} 
                  >  
                    <iframe src={this.props.video} style={{border:'none',overflow:'hidden',height:'100%',width:'100%'}} scrolling="no" frameBorder="0" allowtransparency="true" allow="encrypted-media" allowFullScreen={true} data-autoplay={true} title ="DANTE"></iframe>
                  </div>
                </div>
              </div>
            </div>
                    
          </div>
        )}
      </LangChangeEventContext.Consumer>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/MainKitchen/index.js